const OBSERVER_OPTIONS = {
  rootMargin: '200px 0px',
  threshold: 0.01,
};

const getSource = (value) => {
  if (typeof value === 'string') {
    return value;
  }
  if (value && typeof value === 'object') {
    return value.src || value.image || '';
  }
  return '';
};

const getPlaceholder = (value) => {
  if (value && typeof value === 'object') {
    return value.placeholder || value.fallback || '';
  }
  return '';
};

const loadImage = (el) => {
  const src = el.dataset.lazySrc;
  if (!src || el.dataset.lazyLoaded === 'true') return;
  el.src = src;
  el.dataset.lazyLoaded = 'true';
};

const setupObserver = () => {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return null;
  }
  return new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        loadImage(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, OBSERVER_OPTIONS);
};

const observer = setupObserver();

const observe = (el) => {
  if (!el.dataset.lazySrc) return;
  if (observer) {
    observer.observe(el);
  } else {
    loadImage(el);
  }
};

const unobserve = (el) => {
  if (observer) {
    observer.unobserve(el);
  }
};

export default {
  inserted(el, binding) {
    const src = getSource(binding.value);
    const placeholder = getPlaceholder(binding.value);

    if (!src) return;

    if (placeholder) {
      el.src = placeholder;
    }

    el.dataset.lazyLoaded = 'false';
    el.dataset.lazySrc = src;
    observe(el);
  },
  update(el, binding) {
    const nextSrc = getSource(binding.value);
    const prevSrc = getSource(binding.oldValue);

    if (!nextSrc || nextSrc === prevSrc) return;

    unobserve(el);
    el.dataset.lazyLoaded = 'false';
    el.dataset.lazySrc = nextSrc;
    observe(el);
  },
  unbind(el) {
    unobserve(el);
  },
};
